import React, { Component, Fragment } from 'react'

import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { fetchCategories } from 'actions/cms/categories'
import Collapsible from 'components/collapsible'
import CollapsibleHeader from 'components/collapsible-header'
import { DashedSeparator } from 'components/common'
import theme from 'components/theme'
import CONFIG from 'config'
import e2eClasses from 'helpers/automation'
import { getLinkFromCmsPath } from 'helpers/url/cms'
import { isEmpty, isMobile } from 'helpers/utils'
import { getCategoriesData } from 'selectors/cms/categories'
import { mapMediaType } from 'selectors/mediaType'

import {
  Container,
  Title,
  Subtitle,
  Row,
  Column,
  TableHeader,
  TableBody,
  Link,
  IconWrapper,
  HelpCenterWrapper,
  TitleSimplified,
  ColumnMobileSimplified,
  Image
} from './styled'

class HelpCenter extends Component {
  state = {
    isExtended: true
  }

  componentDidMount() {
    isEmpty(this.props.categories) && this.props.fetchCategories()
  }

  getUrl(url, simplified) {
    return simplified ? getLinkFromCmsPath(url) : url && url.replace(/&amp;/g, `&`)
  }

  getCategoriesContent = simplifiedMobile => {
    const { categories, simplified } = this.props
    const lastItem = categories.length - 1

    return (
      <Row>
        {(categories || []).map((category, index) => (
          <Fragment key={index}>
            <Column simplifiedMobile={simplifiedMobile}>
              {simplified && (
                <IconWrapper>
                  <Image
                    src={`${CONFIG.CONTENT_CDN_BASE_URL}${category.helpIcon}`}
                    alt={category.helpAltText}
                  />
                </IconWrapper>
              )}
              <ColumnMobileSimplified simplifiedMobile={simplifiedMobile}>
                <TableHeader
                  href={this.getUrl(category.helpUrl, simplified)}
                  simplified={simplified}
                >
                  {category.title}
                </TableHeader>
                <TableBody>
                  {(category.helpSectionReference || []).map((section, subindex) => (
                    <Link
                      key={subindex}
                      href={this.getUrl(section.help_section_url, simplified)}
                      simplified={simplified}
                    >
                      {section.title}
                    </Link>
                  ))}
                </TableBody>
              </ColumnMobileSimplified>
            </Column>
            {simplifiedMobile && <DashedSeparator hide={index === lastItem} />}
          </Fragment>
        ))}
      </Row>
    )
  }

  toggleHeader = () => {
    this.setState({ isExtended: !this.state.isExtended })
  }

  getSimplifiedMobileContent = headerTextKey => (
    <Collapsible
      onClick={() => this.toggleHeader()}
      isExtended={this.state.isExtended}
      headerStyledComponent={<CollapsibleHeader simplified headerTextKey={headerTextKey} />}
    >
      <Container backgroundColor={theme.colors.white} simplifiedMobile>
        {this.getCategoriesContent(true)}
      </Container>
    </Collapsible>
  )

  getSimplifiedContent = headerTextKey => (
    <HelpCenterWrapper>
      <TitleSimplified>{this.props.t(headerTextKey)}</TitleSimplified>
      <Container backgroundColor={theme.colors.grayLighter}>
        {this.getCategoriesContent(false)}
      </Container>
    </HelpCenterWrapper>
  )

  getFullContent = headerTextKey => (
    <Container backgroundColor={theme.colors.blue} e2eClass={e2eClasses('helpCenter.helpBox')}>
      <Title>{this.props.t(headerTextKey)}</Title>
      <Subtitle>{this.props.t('general.footer.help-center')}</Subtitle>
      {this.getCategoriesContent(false)}
    </Container>
  )

  render() {
    const { categories, mediaType, simplified } = this.props

    if (isEmpty(categories)) {
      return null
    }

    const simplifiedMobile = isMobile(mediaType) && simplified
    const headerTextKey = 'general.footer.need-help'

    if (simplifiedMobile) {
      return this.getSimplifiedMobileContent(headerTextKey)
    }

    if (simplified) {
      return this.getSimplifiedContent(headerTextKey)
    }

    return this.getFullContent(headerTextKey)
  }
}

const mapStateToProps = state => ({
  categories: getCategoriesData(state),
  mediaType: mapMediaType(state)
})

const mapDispatchToProps = {
  fetchCategories
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(HelpCenter))
